import { Text } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

const CopyableText = ({ title = 'Text', children, ...props }) => {
  const dispatch = useDispatch();

  const onClick = (e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(e.target.innerHTML)
      .then(() => {
        dispatch(
          setAlert({
            title: `${title} copied to clipboard`,
            status: 'success'
          })
        );
      })
      .catch((error) => {
        dispatch(
          setAlert({
            title: `Failed to copy ${title} to clipboard`,
            status: ALERT_STATUS_TYPE.ERROR
          })
        );
      });
  };

  return (
    <Text
      onClick={onClick}
      {...props}
      cursor={'pointer'}
      _hover={{ color: 'colorPrimary', ...props._hover }}
    >
      {children}
    </Text>
  );
};

export default CopyableText;
